<div class="header__arrow back-btn" (click)="onBack($event)"></div>
<section class="default-container vertical-as" id="detail-page" [@zoomOutPage]>
  <div
    class="default-container vertical-as"
    [ngClass]="{ hide: showOverlay, show: !showOverlay }"
    [@zoomStagger]
  >
    <div class="vertical-as default-data">
      <app-content-detail
        [resource]="resource"
        [showDescription]="true"
      ></app-content-detail>
      <div
        class="tvod_hint horizontal-ac"
        *ngIf="resourceAction?.tvodHintText"
        [style]="'fontSize.24' | translate"
      >
        <app-icon
          icon="tvod-info"
          class="tvod_hint_icon"
          *ngIf="showTvodHintIcon()"
        ></app-icon>
        {{ resourceAction.tvodHintText }}
      </div>
      <div
        class="button horizontal-as sub-button horizontal-focusable-container"
        data-down="detail-buttons"
        *ngIf="resourceAction"
        [ngClass]="{ hasTvodHint: resourceAction?.tvodHintText }"
        (focusin)="onContainerFocus(0)"
      >
        <app-icon-button
          [label]="
            resourceAction?.playButtonText ||
            resourceAction?.subscriptionActionText ||
            resourceAction?.tvodButtonText
          "
          [icon]="
            resourceAction?.playButtonText || resourceAction.showTvodButton
              ? 'play'
              : null
          "
          [mode]="resourceAction?.showSubscriptionActionButton || 'normal'"
          width="23.65vw"
          (clicked)="onPlayButtonClick()"
          [isUppercase]="false"
          (focusin)="onBottomOverlayFocus(false, null)"
        ></app-icon-button>

        <app-icon-button
          *ngIf="
            resourceAction?.showTrailerButton ||
            resourceAction?.showStartOverButton
          "
          [icon]="resourceAction?.showStartOverButton ? 'start-over' : null"
          [label]="
            resourceAction?.showStartOverButton
              ? getStartOverLabel()
              : getTrailerLabel()
          "
          [width]="resourceAction?.showStartOverButton ? '12.08vw' : '7.92vw'"
          (clicked)="onTrailerOrStartOverClick()"
          (focusin)="onBottomOverlayFocus(false, null)"
          [customClass]="'detail-btn'"
        ></app-icon-button>
        <button
          class="add-icon-container vertical-center focusable-element"
          *ngIf="resourceAction?.showAddToListButton"
          tabindex="0"
          (focusin)="onAddIcon(true); onBottomOverlayFocus(false, null)"
          (focusout)="onAddIcon(false)"
          (click)="updateFavourite()"
          (mouseenter)="isHovered = true"
          (mouseleave)="isHovered = false"
        >
          <app-icon
            [icon]="favourite ? 'favourite' : 'add'"
            [isFocused]="isAddIconHovered || isHovered"
          ></app-icon>
        </button>
      </div>
      <div
        class="progress-bar"
        *ngIf="
          resourceAction?.showPlayButton && resourceAction?.showStartOverButton
        "
      >
        <div class="progress-bar-fill" [style.width]="watchPercent + '%'"></div>
      </div>
    </div>
  </div>

  <!-- Detail container with its own visibility logic -->
  <div
    class="detail-container vertical-as"
    [ngClass]="{ show: showOverlay, hide: !showOverlay }"
    [style.background-color]="showOverlay ? '#121212' : 'transparent'"
    [@overlayAnimation]
  >
    <div class="info-container" [@containerAnimation]>
      <h1 [style]="'fontSize.28' | translate" *ngIf="showOverlay">
        {{ title }}
      </h1>
      <div
        class="detail-buttons-container"
        [ngClass]="{ show: showOverlay, hide: !showOverlay }"
      >
        <div
          class="detail-buttons horizontal-as horizontal-focusable-container"
          data-up="button"
          [class.is-focused]="showOverlay"
          (focusin)="onContainerFocus(1)"
        >
          <h2
            *ngIf="!isMovie"
            class="episode focusable-element"
            [style]="'fontSize.24' | translate"
            [class.is-selected]="selectedIndex === 0"
            tabindex="0"
            (focusin)="onBottomOverlayFocus(true, 0)"
          >
            {{ tabs[0] }}
          </h2>
          <h2
            class="cast focusable-element"
            [style]="'fontSize.24' | translate"
            [class.is-selected]="selectedIndex === 1"
            tabindex="1"
            (focusin)="onBottomOverlayFocus(true, 1)"
          >
            {{ tabs[1] }}
          </h2>
          <h2
            class="more focusable-element"
            [style]="'fontSize.24' | translate"
            [class.is-selected]="selectedIndex === 2"
            tabindex="2"
            (focusin)="onBottomOverlayFocus(true, 2)"
          >
            {{ tabs[2] }}
          </h2>
        </div>
      </div>
      <hr class="line-divider" *ngIf="showOverlay" />
    </div>

    <div
      class="episode-container vertical-as"
      *ngIf="selectedIndex === 0 && showOverlay"
      [@containerAnimation]
    >
      <div
        class="season-container horizontal-as horizontal-focusable-container"
        data-up="detail-buttons"
        [attr.data-index]="seasonIndex"
        (focusin)="onContainerFocus(2)"
      >
        <div
          class="horizontal-as season-item focusable-element"
          *ngFor="let season of seasons; let i = index; trackBy: trackByIndex"
          (focusin)="onSeasonFocus(i, season)"
          tabindex="0"
        >
          <app-icon
            *ngIf="seasonIndex === i"
            [icon]="'selected-season'"
          ></app-icon>
          <p class="season-name" [style]="'fontSize.24' | translate">
            {{ getSeasonLabel(season.seasonNumber) }}
          </p>
        </div>
      </div>
      <div
        class="episodes-container"
        [style.width]="'100%'"
        (keydown.ArrowRight)="paginate(seasons)"
        [@episodesAnimation]="activeSeasonId"
        (focusin)="onContainerFocus(3)"
      >
        <app-horizontal-carousel
          *ngIf="episodes !== null"
          [containers]="episodes"
          [showHeader]="false"
          [isEpisodeList]="true"
          [aspectRatio]="episodes.aspectRatio"
          [isHalfVisible]="true"
          [showPlayIcon]="true"
          [isTitleVisible]="false"
          [isSeries]="true"
          [isDetailPageEpisodeCards]="true"
          [bookmark]="horizontalCarouselBookmark"
        ></app-horizontal-carousel>
      </div>
    </div>

    <div
      class="cast-container vertical-as"
      *ngIf="selectedIndex === 1 && showOverlay"
      [@containerAnimation]
    >
      <div class="horizontal-as scroll-container">
        <app-cast
          *ngFor="
            let cast of resource.localizedCast;
            let i = index;
            trackBy: trackByIndex
          "
          class="casts horizontal-as"
          [id]="cast.id"
          [localizedName]="cast.localized"
          [roleName]="null"
          [updatedTime]="resource.updatedTime"
          [lang]="lang"
        ></app-cast>
      </div>
      <div class="detail horizontal-as">
        <div class="left vertical-as">
          <p *ngIf="director" [style]="'fontSize.24' | translate">
            {{ "details_screen_director" | translate }}
          </p>
          <p *ngIf="producer" [style]="'fontSize.24' | translate">
            {{ "details_screen_producers" | translate }}
          </p>
          <p *ngIf="studio" [style]="'fontSize.24' | translate">
            {{ "details_screen_studio" | translate }}
          </p>
        </div>
        <div class="right vertical-as">
          <p *ngIf="director" [style]="'fontSize.24' | translate">
            {{ director }}
          </p>
          <p *ngIf="producer" [style]="'fontSize.24' | translate">
            {{ producer }}
          </p>
          <p *ngIf="studio" [style]="'fontSize.24' | translate">{{ studio }}</p>
        </div>
      </div>
    </div>

    <div
      *ngIf="selectedIndex === 2 && showOverlay && moreLikeThis"
      class="more-like-this"
      [@containerAnimation]
    >
      <app-horizontal-carousel
        [containers]="moreLikeThis"
        [showHeader]="false"
        [aspectRatio]="moreLikeThis.aspectRatio"
        [isHalfVisible]="true"
        [showPlayIcon]="false"
        [isTitleVisible]="false"
        (onCardClick)="resetBottomOverlay()"
      ></app-horizontal-carousel>
    </div>

    <div
      *ngIf="selectedIndex === 2 && showOverlay && mostPopular"
      class="most-popular"
      [@containerAnimation]
    >
      <app-horizontal-carousel
        [containers]="mostPopular"
        [showHeader]="true"
        [aspectRatio]="mostPopular.aspectRatio"
        [isHalfVisible]="true"
        [showPlayIcon]="false"
        [isTitleVisible]="false"
        (onCardClick)="resetBottomOverlay()"
      ></app-horizontal-carousel>
    </div>
  </div>
</section>
